import React from 'react';

import CssBaseline from '@material-ui/core/CssBaseline';
import { BrowserRouter } from 'react-router-dom';

import { ThemeWrapper } from '@mvrb-frontend/shared-ui';
import { Provider as GlobalProvider } from './contexts/GlobalContext';
import { Routes } from './constants';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './AppInsights';
import './index.css';

function App() {
  return (
    <ThemeWrapper>
      <BrowserRouter basename="/ors">
        <CssBaseline />
        <GlobalProvider profile={undefined}>
          <Routes />
        </GlobalProvider>
      </BrowserRouter>
    </ThemeWrapper>
  );
}

export default withAITracking(reactPlugin, App);
